<template>
  <div class="newsletter-form">
    <div :class="{ 'animated fadeInUp': subscribed, hidden: !subscribed }">
      <h4>Thank you for subscribing!</h4>
    </div>
    <div class="input-group" :class="{ hidden: subscribed }">
      <input
        v-model="form.data.email"
        type="text"
        class="form-control"
        :class="{ disabled: disabled }"
        placeholder="Enter your email"
        @keyup.enter="form.submit()"
        @blur="markAsChanged()"
      />
      <span class="input-group-btn">
        <button
          :class="{ disabled: disabled }"
          :disabled="disabled"
          class="btn btn-default submit-button"
          type="button"
          @click="form.submit()"
        >
          <loader
            v-show="form.submitInProgress"
            :class="{ 'is-black': loaderBlack }"
          />
          <span v-show="!form.submitInProgress">{{ buttonText }}</span>
        </button>
      </span>
    </div>
    <span v-show="form.hasErrors('email')" class="help-block text-left"
      >Please provide proper e-mail address</span
    >
    <span v-show="disabled && changed" class="help-block text-left"
      >Please toggle the consent checkbox below</span
    >
  </div>
</template>

<script>
import { Form } from '@/utils/forms'

const NEWSLETTER_EMAIL_KEY = 'VESTBEE_NEWSLETTER_EMAIL'

export default {
  props: {
    buttonText: { type: String, default: 'Join our invite list' },
    loaderBlack: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
  },
  data: function () {
    const self = this

    return {
      form: new Form({
        url: '/auth/subscribe',
        fields: [{ name: 'email', type: 'text', label: 'E-mail', default: '' }],
        onSuccess() {
          self.subscribed = true
          self.$emit('subscribed', { email: self.form.data.email })
          setNewsletterEmail(self.form.data.email)
        },
        delay: 1000,
        useAuthToken: false,
      }),
      subscribed: false,
      changed: false,
    }
  },
  methods: {
    markAsChanged() {
      this.changed = true
    },
  },
}

function setNewsletterEmail(email) {
  if (sessionStorage) {
    sessionStorage.setItem(NEWSLETTER_EMAIL_KEY, email)
  }
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

.submit-button {
  box-shadow: none;
}

.disabled {
  &.submit-button {
    background: $grey90 !important;
  }

  &.form-control {
    border: 2px solid $grey120 !important;
  }

  &.form-control::placeholder {
    color: $grey90 !important;
  }
}
</style>
